import { HeroSectionMobile } from "./HeroSectionMobile";
import { HeroSectionDesk } from "./HeroSectionDesk";

export const HeroSection = () => {

  return (
    <>
      <HeroSectionMobile />
      <HeroSectionDesk />
    </>
  );
};
